/**
 * @generated SignedSource<<b435d52f0321da17401ff06ff87367a9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamScheduleAdminArchivedScreenListItem_routine$data = {
  readonly id: string;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleRoutineListItemContent_Routine">;
  readonly " $fragmentType": "TeamScheduleAdminArchivedScreenListItem_routine";
};
export type TeamScheduleAdminArchivedScreenListItem_routine$key = {
  readonly " $data"?: TeamScheduleAdminArchivedScreenListItem_routine$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleAdminArchivedScreenListItem_routine">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamScheduleAdminArchivedScreenListItem_routine",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamScheduleRoutineListItemContent_Routine"
    }
  ],
  "type": "Routine",
  "abstractKey": null
};

(node as any).hash = "86b430d5059f976cdf48aac79329c0d5";

export default node;
